<template>
  <nav class="config-nav">
    <div class="config-nav__intro-text" v-if="!editingFeelingLucky">
      <transition name="slidein">
        <h4 v-show="show" class="config-nav__heading">Let's get this party started</h4>
      </transition>
      <transition name="slidein2">
        <p
          v-show="show"
        >Just select a speaker part and start playing. You can add custom text, custom colors, even custom fabric. In no time you’ll have your very own creation.</p>
      </transition>
    </div>
    <div class="config-nav__intro-text" v-else>
      <transition name="slidein">
        <h4 v-show="show" class="config-nav__heading">
          OK great start.
          <br>Let's finish this.
        </h4>
      </transition>
      <transition name="slidein2">
        <p
          v-show="show"
        >Select the part of the speaker you want to change. You can add custom text, change colors, even change fabric. When you've nailed it. just hit continue.</p>
      </transition>
    </div>
    <button
      :disabled="currentRouteIndex() === 0"
      class="config-nav__btn-in-list config-nav__previous-in-list"
      @click="previousOptionInList"
    >
      <span class="sr-only">Previous</span>
    </button>
    <button
      :disabled="!(currentRouteIndex() < pages.length - 1) && typeof(selectionsMade()) !== 'boolean'"
      class="config-nav__btn-in-list config-nav__next-in-list"
      @click="nextOptionInList"
    >
      <span class="sr-only">Next</span>
    </button>
    <transition-group name="slidein3" tag="ul" class="config-nav__list">
      <router-link
        v-for="page in pages"
        :key="page.route"
        tag="li"
        v-show="show"
        :class="selectionMade(page.name) ? 'config-nav__item config-nav__item--checked' : 'config-nav__item'"
        active-class="config-nav__item--active"
        :to="{name: page.name }"
      >
        <a class="config-nav__link">
          {{page.text}}
          <span class="config-nav__selected-option">&nbsp;{{selectedOption(page.name)}}</span>
        </a>
      </router-link>
    </transition-group>
    <transition name="slidein4">
      <button
        @click="nextOption"
        data-text="Continue"
        v-show="show"
        class="btn btn--right btn--inverse config-nav__next"
      >Continue</button>
    </transition>
  </nav>
</template>

<script>
import { EventBus } from "../eventBus";
import * as EmojiStrip from "emoji-strip";

export default {
  name: "ConfigNavigation",
  data() {
    return {
      // this just helps to build the router and determine what the next option is. it is tightly tied to state.configuration and to the router itself
      // name corresponds to state.configuration[name]
      // text is the text for the navigation
      // route is the actual piece of the router e.g. /configure/:route
      show: false,
      pages: [
        {
          name: "Fabric",
          text: "Fabric Pattern",
          route: "fabric"
        },
        {
          name: "Caps",
          text: "End Caps",
          route: "caps"
        },
        {
          name: "Icon",
          text: "Volume Buttons",
          route: "icons"
        },
        {
          name: "Spine",
          text: "Spine",
          route: "spine"
        },
        {
          name: "Loop",
          text: "Loop",
          route: "loop"
        },
        {
          name: "CustomText",
          text: "Text",
          route: "text"
        }
      ]
    };
  },
  computed: {
    configuredSelections() {
      return this.$store.state.configuration;
    },
    activePageIndex() {
      return this.pages.findIndex(page => page.name === this.$route.name);
    },
    editingFeelingLucky() {
      return this.$store.state.editingFeelingLucky;
    }
  },
  mounted() {
    this.show = true;
    const that = this;
    var ce = function(e, n) {
        var a = document.createEvent("CustomEvent");
        a.initCustomEvent(n, true, true, e.target);
        e.target.dispatchEvent(a);
        a = null;
        return false;
      },
      nm = true,
      sp = {
        x: 0,
        y: 0
      },
      ep = {
        x: 0,
        y: 0
      },
      touch = {
        touchstart: function(e) {
          sp = {
            x: e.touches[0].pageX,
            y: e.touches[0].pageY
          };
        },
        touchmove: function(e) {
          nm = false;
          ep = {
            x: e.touches[0].pageX,
            y: e.touches[0].pageY
          };
        },
        touchend: function(e) {
          if (nm) {
            ce(e, "fc");
          } else {
            var x = ep.x - sp.x,
              xr = Math.abs(x),
              y = ep.y - sp.y,
              yr = Math.abs(y);
            if (Math.max(xr, yr) > 20) {
              ce(e, xr > yr ? (x < 0 ? "swl" : "swr") : y < 0 ? "swu" : "swd");
            }
          }
          nm = true;
        },
        touchcancel: function(e) {
          nm = false;
        }
      };
    for (var a in touch) {
      document.addEventListener(a, touch[a], false);
    }
    var nextOption = function(e) {
      that.nextOptionInList();
    };
    var prevOption = function(e) {
      that.previousOptionInList();
    };
    mediaCheck({
      media: "(min-width: 992px)",
      entry: function() {
        if ($(".config-nav__list").hasClass("slick-initialized")) {
          $(".config-nav__list").slick("unslick");
        }
        document
          .querySelector(".config-top")
          .removeEventListener("swl", nextOption, false);
        document
          .querySelector(".config-top")
          .removeEventListener("swr", prevOption, false);
      },
      exit: function() {
        //EXAMPLE OF USE
        document
          .querySelector(".config-top")
          .addEventListener("swl", nextOption, false);
        document
          .querySelector(".config-top")
          .addEventListener("swr", prevOption, false);
        let activePage = that.activePageIndex;
        $(".config-nav__list").slick({
          centerMode: true,
          slidesToShow: 1,
          focusOnSelect: true,
          infinite: false,
          variableWidth: true,
          arrows: false,
          swipe: false,
          initialSlide: activePage
        });
        $(".config-nav__list").slick("setPosition");
      }
    });
  },
  watch: {
    $route(to, from) {
      if ($(".config-nav__list").hasClass("slick-initialized")) {
        $(".config-nav__list").slick("slickGoTo", this.activePageIndex);
        $(".config-nav__list").slick("setPosition");
      }
      if (from.name === "CustomText") {
        // set the text
        const inputText = this.$store.state.inputText;
        const customText = this.$store.state.configuration.CustomText;
        if (inputText === null || inputText.length === 0) {
          this.$store.commit("updateCustomText", "");
        }
      }
    }
  },
  methods: {
    selectionMade(item) {
      if (this.$store.state.configuration[item] !== null) {
        return true;
      }
      return false;
    },
    selectedOption(item) {
      const optionId = this.$store.state.configuration[item];
      const productOptions = this.$store.state.productOptions[item];
      if (item === "CustomText") {
        return this.$store.state.configuration.CustomText;
      } else {
        if (productOptions) {
          const option = productOptions.Options.filter(
            option => option.Id === optionId
          )[0];
          if (option) {
            return option.Name;
          }
          return "";
        } else {
          return "";
        }
      }
    },
    currentRouteIndex() {
      const pages = this.pages;
      const currentPageName = this.$route.name;
      return pages.findIndex(item => item.name === currentPageName);
    },
    previousOptionInList() {
      // this goes to the previous option in the list, not the previous option that needs a selection.
      const pages = this.pages;
      const routeIndex = this.currentRouteIndex();
      if (this.currentRouteIndex() > 0) {
        this.$router.push({
          name: `${pages[routeIndex - 1].name}`
        });
      } else {
        console.log("cannot go anywhere - disable me");
      }
      $(".config-nav__list").slick("setPosition");
    },
    nextOptionInList() {
      const pages = this.pages;
      const routeIndex = this.currentRouteIndex();
      // this goes to the next option in the list, not the next option that needs a selection.
      if (this.currentRouteIndex() < pages.length - 1) {
        this.$router.push({
          name: `${pages[routeIndex + 1].name}`
        });
      } else {
        let moveOn = false;
        const selections = this.selectionsMade();
        if (typeof selections === "boolean") {
          const inputText = this.$store.state.inputText;
          if (inputText === null) {
            // change to an empty string
            this.$store.commit("updateCustomText", "");
            moveOn = true;
          } else if (inputText !== this.$store.state.configuration.CustomText) {
            const myText = EmojiStrip(inputText.trim().toUpperCase());
            const hasBadWord = this.$store.state.forbiddenText.some(
              bad => myText.indexOf(bad) > -1
            );
            if (hasBadWord) {
              // show error and do not change pages
              console.error("Text contains forbidden words. Please correct.");
              EventBus.$emit("textError", true);
              moveOn = false;
            } else {
              this.$store.commit(
                "updateCustomText",
                this.$store.state.inputText
              );
              EventBus.$emit("textError", false);
              moveOn = true;
            }
          } else {
            moveOn = true;
          }
          if (moveOn) {
            this.$router.push({ path: "/configure/completed" });
          }
        }
      }
      $(".config-nav__list").slick("setPosition");
    },
    selectionsMade() {
      // returns true if all selections are made, or returns the next page to go to
      const selections = this.configuredSelections;
      let unselected = false;

      for (var i = 0; i < this.pages.length; i++) {
        const page = this.pages[i];
        if (selections[page.name] === null) {
          // no selection has been made. let's navigate to that page
          // if user hits continue and the page they are ON is the one, just continue past it, unless it's the last one in the list
          unselected = true;
          if (page.name !== this.$route.name) {
            return page;
          }
        }
      }
      return true;
    },
    nextOption() {
      const selections = this.configuredSelections;
      let unselected = false;
      let moveOn;

      // if this is the CustomText page, we want to save the entered text
      if (this.$route.name === "CustomText") {
        // do stuff
        const inputText = this.$store.state.inputText;

        if (inputText === null) {
          // change to an empty string
          this.$store.commit("updateCustomText", "");
          moveOn = true;
        } else if (inputText !== this.$store.state.configuration.CustomText) {
          const myText = EmojiStrip(inputText.trim().toUpperCase());
          const hasBadWord = this.$store.state.forbiddenText.some(
            bad => myText.indexOf(bad) > -1
          );
          if (hasBadWord) {
            // show error and do not change pages
            console.error("Text contains forbidden words. Please correct.");
            EventBus.$emit("textError", true);
            moveOn = false;
          } else {
            this.$store.commit("updateCustomText", this.$store.state.inputText);
            EventBus.$emit("textError", false);
            moveOn = true;
          }
        } else {
          moveOn = true;
        }
      } else {
        moveOn = true;
      }

      if (moveOn) {
        // loop over pages in order. if it finds one that hasn't been completed, goes to it.
        for (var i = 0; i < this.pages.length; i++) {
          const page = this.pages[i];
          if (selections[page.name] === null) {
            // no selection has been made. let's navigate to that page
            // if user hits continue and the page they are ON is the one, just continue past it, unless it's the last one in the list
            unselected = true;
            if (page.name !== this.$route.name) {
              return this.$router.push({ name: page.name });
            }
          }
        }

        // otherwise if all pages have a choice made, continue to the completed design page
        if (!unselected) {
          this.$router.push({ name: "completed-design" });
        }
      }
    }
  }
};
</script>


<style scoped lang="scss">
@import "../scss/variables";
.config-nav {
  &__heading {
    text-transform: uppercase;
    font-size: 1.2em;
    margin-top: 0;
    margin-bottom: 1em;
    color: #000;
  }
  &__intro-text {
    display: none;
    @media (min-width: 992px) {
      display: block;
      color: #676767;
      margin-bottom: 1.5em;
      line-height: 1.3;
      @media (min-height: 715px) {
        max-width: 300px;
      }
    }
    p {
      font-size: 0.9em;
      font-family: sans-serif;
    }
  }
  &__btn-in-list {
    position: absolute;
    top: 50%;
    font-size: 50px;
    line-height: 1;
    background: none transparent;
    padding: 0;
    border: none;
    cursor: pointer;
    transform: translateY(-100%);
    &[disabled] {
      cursor: not-allowed;
    }
    @media (min-width: 992px) {
      display: none;
    }
  }
  &__next-in-list {
    right: 1rem;
    &:before {
      content: "\f105";
      font-family: FontAwesome;
    }
  }
  &__previous-in-list {
    left: 1rem;
    &:before {
      content: "\f104";
      font-family: FontAwesome;
    }
  }
  &__selected-option {
    font-size: 1rem;
    font-weight: normal;
    opacity: 0;
    display: block;
    .config-nav__item--active & {
      opacity: 1;
    }
    @media (min-width: 992px) {
      display: none;
    }
  }
  &__list {
    list-style: none outside;
    text-transform: uppercase;
    padding: 0;
    line-height: 1.4;
    display: flex;
    overflow: hidden;
    font-weight: bold;
    font-size: 1.3em;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    @media (min-width: 768px) {
      font-size: 2em;
    }
    @media (min-width: 992px) {
      display: block;
      font-size: 1.4em;
      overflow: visible;
      margin-bottom: 0.75em;
      @media (min-height: 715px) {
        font-size: 1.75em;
      }
    }
  }
  &__item {
    color: $greyDark;
    margin-right: 1em;
    text-align: center;
    @media (min-width: 992px) {
      text-align: left;
      white-space: nowrap;
      color: $greyMidDark;
      position: relative;
      padding-left: 32px;
      &:before {
        content: "";
        font-weight: bold;
        display: block;
        width: 10px;
        height: 10px;
        border-radius: 100%;
        border: 2px solid currentColor;
        text-align: center;
        box-sizing: border-box;
        margin-right: 0.25em;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      &--checked {
        &:before {
          content: "";
          border-radius: 100%;
          width: 20px;
          height: 20px;
          left: -2px;
          background: currentColor url("/images/checkmark.png") center center
            no-repeat;
          background-size: 12px auto;
        }
        @media (min-height: 715px) {
          &:before {
            background-size: 16px auto;
            width: 27px;
            height: 27px;
            left: -8px;
          }
        }
      }
    }
    &--active {
      color: #000;
    }
  }
  &__link {
    text-decoration: none;
    color: currentColor;
    display: block;
    width: 100%;
    padding-left: 1em;
    padding-right: 1em;
    box-sizing: border-box;
    @media (min-width: 992px) {
      display: inline;
      width: auto;
      padding: 0;
      transition: opacity 0.25s;
      &:hover {
        opacity: 0.8;
      }
    }
  }
  &__next {
    display: none;
    @media (min-width: 992px) {
      display: block;
    }
  }
}

.slidein-enter-active,
.slidein-leave-active {
  transition: opacity 0.5s, transform 0.5s;
  transition-delay: 0.1s;
}

.slidein2-enter-active,
.slidein2-leave-active {
  transition: opacity 0.5s, transform 0.5s;
  transition-delay: 0.2s;
}

.slidein3-enter-active,
.slidein3-leave-active {
  transition: opacity 0.5s, transform 0.5s;
  transition-delay: 0.3s;
  &:nth-child(1) {
    transition-delay: 0.3s;
  }
  &:nth-child(2) {
    transition-delay: 0.4s;
  }
  &:nth-child(3) {
    transition-delay: 0.5s;
  }
  &:nth-child(4) {
    transition-delay: 0.6s;
  }
  &:nth-child(5) {
    transition-delay: 0.7s;
  }
  &:nth-child(6) {
    transition-delay: 0.8s;
  }
}

.slidein4-enter-active,
.slidein4-leave-active {
  transition: opacity 0.5s, transform 0.5s;
  transition-delay: 0.9s;
}

.slidein-enter,
.slidein-leave-to,
.slidein2-enter,
.slidein2-leave-to,
.slidein3-enter,
.slidein3-leave-to,
.slidein4-enter,
.slidein4-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
</style>
